import {HttpParams} from '@angular/common/http';
import {Component, OnDestroy, OnInit} from '@angular/core';
// import { ChartOptions, ChartType, ChartDataSets } from 'chart.js';
import * as _ from 'lodash';
import * as moment from 'moment';
import {Chart} from 'chart.js';

import {ApiService} from '../../../services/api.service';
import {AuthenticationService} from '../../../services/authentication.service';
import {SelectItem} from 'primeng/api';
import {SubSink} from 'subsink';
import {Router} from '@angular/router';

@Component({
  selector: 'app-dashboard-sms',
  templateUrl: './dashboard-sms.component.html',
  styleUrls: ['./dashboard-sms.component.scss']
})
export class DashboardSmsComponent implements OnInit, OnDestroy {
  // month amount to show in graph
  monthAmount = 6;
  // activity amount to show in activity list
  activityAmount = 2;
  monthList = [
    'มกราคม',
    'กุมภาพันธ์',
    'มีนาคม',
    'เมษายน',
    'พฤษภาคม',
    'มิถุนายน',
    'กรกฎาคม',
    'สิงหาคม',
    'กันยายน',
    'ตุลาคม',
    'พฤศจิกายน',
    'ธันวาคม'
  ];
  monthListDropdown = [
    {label: 'มกราคม', value: 1},
    {label: 'กุมภาพันธ์', value: 2},
    {label: 'มีนาคม', value: 3},
    {label: 'เมษายน', value: 4},
    {label: 'พฤษภาคม', value: 5},
    {label: 'มิถุนายน', value: 6},
    {label: 'กรกฎาคม', value: 7},
    {label: 'สิงหาคม', value: 8},
    {label: 'กันยายน', value: 9},
    {label: 'ตุลาคม', value: 10},
    {label: 'พฤศจิกายน', value: 11},
    {label: 'ธันวาคม', value: 12}
  ];
  yearList: any[] = [];
  selectedCompany: SelectItem[];
  company: any;
  selectedHomeproGroup: SelectItem[];
  homeproGroup: any;
  selectedMonth: any;
  selectedYear: any;
  activityList: any;
  selectedDate: Date = new Date();

  charts_bar_stacked: any = null;
  charts_sms_counter_bar_stackeds: any = null;
  charts_signing_counter_line: any = null;
  chartLabels = [];
  monthly_loading = false;
  daily_loading = false;
  bar_stacked_title = '';
  charts_sms_counter_bar_stacked_title = '';
  charts_transaction_count_title = '';
  downloading = false;

  private subs = new SubSink();

  constructor(
    private apiService: ApiService,
    private router: Router,
    private authService: AuthenticationService
  ) {
    if (this.authService.isViewer()) {
      this.router.navigate(['/search']);
    }
  }

  ngOnInit() {
    this.populateDropdown();
    this.loadGraph();
    this.loadMonthlyDatasms();
    this.loadActivity();
  }

  populateDropdown() {
    this.company = [
      {
        label: 'ทั้งหมด',
        value: null
      }
    ];

    this.subs.add(
      this.apiService.getCompany().subscribe(result => {
        _.forEach(result, obj => {
          this.company.push({
            label: obj.name,
            value: obj.tax_id
          });
        });
      })
    );

    this.homeproGroup = [
      {
        label: 'ทั้งหมด',
        value: null
      }
    ];

    this.subs.add(
      this.apiService.getCompanyGroup().subscribe(result => {
        _.forEach(result, obj => {
          this.homeproGroup.push({
            label: obj.name + ' (' + obj.short_name + ')',
            value: obj.id
          });
        });
      })
    );

    const currentDate = new Date();
    // populate year list back within 10 years
    const thisYear = currentDate.getFullYear();
    for (let i = 0; i <= 10; i++) {
      this.yearList.push({label: (thisYear - i).toString(), value: thisYear - i});
    }

    // set current month and year
    this.selectedMonth = currentDate.getMonth() + 1;
    this.selectedYear = thisYear;
  }

  loadGraph() {
    const currentDate = new Date();
    let year = currentDate.getFullYear();
    let month = currentDate.getMonth() - this.monthAmount + 2;

    while (month <= 0) {
      year--;
      month += 12;
    }

    // populate chart label by month and year
    for (let i = 0; i < this.monthAmount; i++, month++) {
      if (month > 12) {
        month = 1;
        year++;
      }
      this.chartLabels.push(month + '/' + year);
    }

    // get graph data from API
    const data = {
      month_amount: this.monthAmount
    };
    // this.subs.add(this.apiService.getDashboardLengthData(data).subscribe((obj: any) => {}));
  }

  // load data from current month
  loadMonthlyDatasms() {
    const data = {
      year: this.selectedYear
    };

    if (this.selectedCompany != null) {
      data['seller_tax_id'] = this.selectedCompany;
    }

    if (this.selectedHomeproGroup != null) {
      data['group_id'] = this.selectedHomeproGroup;
    }

    this.monthly_loading = true;
    this.subs.add(
      this.apiService.getDashboardSMSMonthlyData(data).subscribe((obj: any) => {
        this.monthly_loading = false;

        this.create_sms_counter_bar_stacked(obj.sms_counter);

        Chart.plugins.register({
          beforeDraw: function (chart) {
            if (chart.config.options.elements.center) {
              chart.clear();
              // Get ctx from string
              const ctx = chart.chart.ctx;

              // Get options from the center object in options
              const centerConfig = chart.config.options.elements.center;
              const fontStyle = centerConfig.fontStyle || 'Arial';
              const txt = centerConfig.text;
              const color = centerConfig.color || '#000';
              const sidePadding = centerConfig.sidePadding || 20;
              const sidePaddingCalculated = (sidePadding / 100) * (chart.innerRadius * 2);
              // Start with a base font of 30px
              ctx.font = '30px ' + fontStyle;
              const stringWidth = ctx.measureText(txt).width;
              const elementWidth = chart.innerRadius * 2 - sidePaddingCalculated;

              // Find out how much the font can grow in width.
              const widthRatio = elementWidth / stringWidth;
              const newFontSize = Math.floor(30 * widthRatio);
              const elementHeight = chart.innerRadius * 2;

              // Pick a new font size so it will not be larger than the height of label.
              const fontSizeToUse = Math.min(newFontSize, elementHeight);

              // Set font settings to draw it correctly.
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              const centerX = (chart.chartArea.left + chart.chartArea.right) / 2;
              const centerY = (chart.chartArea.top + chart.chartArea.bottom) / 1.2;
              ctx.font = fontSizeToUse + 'px ' + fontStyle;
              ctx.fillStyle = color;

              // Draw text in center
              ctx.fillText(txt, centerX, centerY);
            }
          },

          afterDraw: function (chart) {
            if (chart.data.datasets.length === 0) {
              // No data is present
              const ctx = chart.chart.ctx;
              const width = chart.chart.width;
              const height = chart.chart.height;
              chart.clear();

              ctx.save();
              ctx.textAlign = 'center';
              ctx.textBaseline = 'middle';
              ctx.font = '14pt Tahoma';
              ctx.fillStyle = '#000';
              ctx.fillText('ไม่ข้อมูลแสดง', width / 2, height / 2);
              ctx.restore();
            }
          }
        });
      })
    );
  }

  create_sms_counter_bar_stacked(data) {

    const sms_success = data.sms_success;
    const sms_failed = data.sms_failed;
    const color = Chart.helpers.color;

    this.charts_sms_counter_bar_stacked_title = 'จำนวนครั้งการส่ง SMS รายเดือน';
    const barChartData = {
      labels: this.monthList,
      datasets: [

        {
          label: 'Success',
          backgroundColor: color('rgb(75, 192, 192)')
            .alpha(0.5)
            .rgbString(),
          borderColor: 'rgb(75, 192, 192)',
          data: sms_success
        },

        {
          label: 'Failed',
          backgroundColor: color('rgb(255, 99, 132)')
            .alpha(0.5)
            .rgbString(),
          borderColor: 'rgb(255, 99, 132)',
          data: sms_failed
        }
      ]
    };

    if (this.charts_sms_counter_bar_stackeds == null) {
      this.charts_sms_counter_bar_stackeds = new Chart('sms-counter-bar-chart', {
        type: 'bar',
        data: barChartData,
        options: {
          tooltips: {
            titleFontSize: 17,
            bodyFontSize: 17,
            mode: 'index',
            intersect: false,
            callbacks: this.getformatLabelFunction('ครั้ง', true)
          },
          responsive: true,
          maintainAspectRatio: false,
          scales: {
            xAxes: [
              {
                stacked: true
              }
            ],
            yAxes: [
              {
                stacked: true,
                ticks: {
                  beginAtZero: true,
                  callback: function (value) {
                    if (value % 1 === 0) {
                      return value;
                    }
                  }
                }
              }
            ]
          },
          legend: {
            position: 'top'
          }
        }
      });
    } else {
      this.charts_sms_counter_bar_stackeds.data = barChartData;
      this.charts_sms_counter_bar_stackeds.update();
    }
  }

  loadActivity() {
    const data = {
      amount: this.activityAmount
    };
    this.subs.add(
      this.apiService.getDashboardActivity(data).subscribe(
        (obj: any) => {
          this.activityList = obj;
        },
        error => {
        }
      )
    );
  }

  formatCurrency(currency) {
    return parseFloat(currency)
      .toFixed(2)
      .replace(/\d(?=(\d{3})+\.)/g, '$&,');
  }

  getformatLabelFunction(unitName, showSum) {
    const tooltip = {
      label: function (tooltipItem, data) {
        let dataLabel = data.datasets[tooltipItem.datasetIndex].label;
        if (dataLabel == null) {
          dataLabel = data.labels[tooltipItem.index];
        }

        const value = data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
        const valueStr = ' : ' + value.toLocaleString();
        dataLabel += valueStr + ' ' + unitName;

        if (showSum) {
          window['total'] += value;
        }

        return dataLabel;
      }
    };

    if (showSum) {
      tooltip['afterTitle'] = function () {
        window['total'] = 0;
      };

      tooltip['footer'] = function () {
        return ['รวมทั้งหมด : ' + window['total'].toLocaleString() + ' ' + unitName];
      };
    }

    return tooltip;
  }

  downloadSMSReport() {
    this.downloading = true;
    const params = {
      year: this.selectedYear,
      seller_tax_id: this.selectedCompany || ''
    }
    this.apiService.getSMSExcelReport(params).subscribe(
      (result) => {
        this.downloading = false;
        let filename = `sms_report_${this.selectedYear}`
        filename = this.selectedCompany ? `${filename}_${this.selectedCompany}.xlsx` : `${filename}.xlsx`
        this.apiService.createDownloadFile(result, filename)
        this.sniff('DOWNLOAD_SMS_REPORT', filename)
      },
      (error) => {
        this.downloading = false;
      }
    )
  }

  sniff(action, detail) {
    const data = {
      action: action,
      feature: 'HOME',  // TODO: *download sms report
      detail: detail
    };
    this.apiService.sniff(data).subscribe();
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}



// WEBPACK FOOTER //
// /opt/app/src/app/features/dashboard/dashboard-sms/dashboard-sms.component.ts